import styled from 'styled-components';
import { ShowMoreButton } from "./../../../NPA/Pages/Step3Review_Submit/Components/LegacyAccordions/styles.js";

export const Header = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.5;
    color: ${props => props.theme.fontColors.white};
    padding: 14px 35px 8px 30px;
    background-color: ${props => props.theme.backgroundColor.primaryColor};
    margin-bottom: ${props => props.marginBottom};

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 10px 20px;
        font-size: ${props => props.theme.fontSize.secondary};
        line-height: 1.71;
    }
`
export const DesktopHeader = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.5;
    color: ${props => props.theme.fontColors.white};
    padding: 14px 35px 8px 30px;
    background-color: ${props => props.theme.backgroundColor.primaryColor};
    margin-bottom: ${props => props.marginBottom};
    display: inherit;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        display:none;
    }
`
export const MobileHeader = styled.div`
    display:none;
    background-color: ${props => props.theme.backgroundColor.primaryColor};
    .ant-collapse{
        background-color: transparent;
        border: 0;
        border-radius: 0;
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        display: block
        padding:  12px 20px 10px 20px;
        font-size: ${props => props.theme.fontSize.secondary};
        line-height: 1.71;
        .ant-collapse > .ant-collapse-item > .ant-collapse-header{
            padding: 0px !important;
            color: ${props => props.theme.fontColors.white};
            font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
        }
        .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow{
            right: 0px;
            left: unset;
        }
        .ant-collapse-content{
            background-color: transparent;
            color: ${props => props.theme.fontColors.white};
            font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
        }
        .ant-collapse-content > .ant-collapse-content-box{
            padding: 0 !important;
        }
        .ant-collapse > .ant-collapse-item{
            i > svg{
                transform: rotate(90deg) !important;
            }
            &.ant-collapse-item-active i > svg{
                transform: rotate(270deg) !important;
            }
        }
    }
`

export const ValueWrap = styled.div`
    margin-bottom: ${props => props.marginBottom};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-bottom: ${props => props.MmarginBottom};
    }
`

export const KeyStyle = styled.span`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.5;
    color: ${props => props.theme.fontColors.textColor};
    padding-right: ${props => props.paddingRight};
    padding-left: 30px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
        line-height: 1.43;
        padding-left: 0;
        padding-right: 0;
    }
`

export const Valuestyle = styled.span`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.5;
    color: ${props => props.theme.fontColors.headingColor};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
        line-height: 1.43;
    }
`

export const DividerWrap = styled.div`
    .ant-divider-horizontal {
        margin: 0;
        background: #b6bdbd;
    }
     margin-bottom: ${props => props.marginBottom};
     
     @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-bottom: ${props => props.MmarginBottom};
     }
`

export const FeeHead = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.5;
    color: ${props => props.theme.fontColors.headingColor};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
        line-height: 1.43;
        letter-spacing: normal;
        margin-bottom: 10px;
    }
`

export const DisplayWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${props => props.marginBottom};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        display: unset;
    }
`

export const ShowMoreButtonStyle = styled(ShowMoreButton)`
    margin: 0;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin: ${props => props.marginVal};
        height:30px !important;
    }
`
export const TranText = styled.p`
    height: fit-content;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.secondary};
    font-weight: ${props => props.theme.fontWeight.normal};
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    color: ${props => props.theme.fontColors.textColor};
    @media only screen and (max-width: 767px){
        margin-top: 50px;
    }
`
export const FlexDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding-top: 10px;
    &>div{
        width:50%;
    }
`
export const FeeTableContainer = styled.div`   
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 0px 20px 20px;
    }
`